module.exports = __webpack_public_path__ + "img/chrome.e8685420.png";